import {GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {Text} from '@/components/ui/text/Text'
import {StyledReadonlySubRegimeField} from '@/features/projects/components/project-form/project-care-fields/style'
import {ProjectFieldsSchema} from '@/features/projects/formSchemas'
import {assistiveRegimeToRehabCareCommitment} from '@/features/projects/utils'
import {useTranslation} from '@/translations/i18n'
import {useFormContext, useWatch} from 'react-hook-form'
import {z} from 'zod'

const ProjectRehabCareCommitmentDataSchema = ProjectFieldsSchema.pick({
    sector: true,
    assistiveRegime: true
})
type ProjectRehabCareCommitmentDataSchema = z.infer<typeof ProjectRehabCareCommitmentDataSchema>

export const ProjectRehabCareCommitmentData = () => {
    const {t} = useTranslation()
    const {control} = useFormContext<ProjectRehabCareCommitmentDataSchema>()
    const sector = useWatch({control, name: 'sector'})
    const assistiveRegime = useWatch({control, name: 'assistiveRegime'})

    const isOutPatientOrMixed = sector == 'outpatient' || sector == 'mixed'

    return (
        <GridItem direction="column" gap={1.5} fullWidth>
            <Text palette="neutral" shade="500" weight="500" size="textSm">
                {t('projects:rehab_care_commitment')}
            </Text>
            {!sector || (isOutPatientOrMixed && !assistiveRegime) ? (
                <StyledReadonlySubRegimeField size="textSm" weight="500">
                    -
                </StyledReadonlySubRegimeField>
            ) : sector == 'domiciliary' ? (
                <StyledReadonlySubRegimeField size="textSm" weight="500">
                    {t('projects:not_applicable')}
                </StyledReadonlySubRegimeField>
            ) : isOutPatientOrMixed && assistiveRegime ? (
                <StyledReadonlySubRegimeField size="textSm" weight="500">
                    {t('commons:duration_minutes', {value: assistiveRegimeToRehabCareCommitment[assistiveRegime]})}
                </StyledReadonlySubRegimeField>
            ) : null}
        </GridItem>
    )
}
